import { ICrossSellB2CData } from "../types/cross-sell-types.types";
import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { encryptedRequest } from "../core/api.client";
// Stub: ICartItemDetails mirrors @repo/connection-manager/types – update once resolution is fixed.
// import type { ICartItemDetails } from "@repo/connection-manager/types";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ICartItemDetails = Record<string, unknown>;

export interface ILoanSummaryB2CRequest {
  mobileNo: string;
  requestedLoanAmt: string;
  loanVariant: string;
  requestedLoanTenor: string;
  requestedIRR: string;
  subsequentTenor?: string;
  initialTenor?: string;
  productList?: ICrossSellB2CData[];
  dob?: string;
  offerId?: string;
  offerProduct?: string;
  sourcingBranchId?: string;
  processType?: string;
  addressState?: string;
  employmentType?: string;
  loanType?: string;
  processSegmentation?: string;
  journeyName?: string;
}

export interface ILoanSummaryB2CResponse {
  chargeDetails: ChargeDetails[];
  emiAmt: string;
  droplineEMIAmt: string;
  hybridEMIAmt: string;
}

export interface ChargeDetails {
  chargeAmt: string;
  chargeCalType: string;
  chargeCollectionMethod: string;
  chargeName: string;
  pennantFeeCode: string;
  typeOfCharge: string;
}
export interface ICallBackRequest {
  business: string;
  mobileNo: string;
  journeyName: string;
  sourcingBranch: string;
  displayName: string;
  offerId: string;
  custId: string;
  prospectId: string;
}

export const getLoanSummaryB2C = async (
  LoanSummaryRequest: ILoanSummaryB2CRequest,
  cancelSignal?: AbortSignal
) => {
  const response = await encryptedRequest<ILoanSummaryB2CResponse, ILoanSummaryB2CRequest>({
    method: "POST",
    url: API_PATHS.loanSummaryCharge,
    data: {
      ...LoanSummaryRequest,
    },
    signal: cancelSignal,
  });

  return response;
};

export const getCallBack = async (callBackRequest: ICallBackRequest) => {
  const response = await encryptedRequest<ICallBackRequest>({
    method: "POST",
    url: API_PATHS.getACallBack,
    data: {
      ...callBackRequest,
    },
  });
  return response;
};

export interface ILoanSummaryDoacResponse {
  cartDetails: ICartItemDetails[] | null;
  productWiseTenorsList: ITenoreListItem[];
  offerList: IOfferDOACListItem[];
  roi: ILoanSummaryRoiListItem[];
  ruralTenors: ITenorObj;
  urbanTenors: ITenorObj;
}

export interface ITenorObj {
  selfemp: ITenoreListItem[];
  sal: ITenoreListItem[];
}

export interface IOfferDOACListItem {
  displayName: string;
  employmentType: string;
  offerId: string;
  offerProduct: string;
  currentResidenceState: string;
  amount: string;
  loanType: string;
  existingLan: string;
}

export interface ILoanSummaryRoiListItem {
  loanAmtFrom: string;
  loanAmtTo: string;
  value: string;
  extId: number;
  minTenor: string;
  maxTenor: string;
}

export interface ITenoreListItem {
  minTenor: number;
  maxTenor: number;
  minLoanAmount: number;
  maxLoanAmount: number;
  allowedTenor: number[];
  pname: string;
}

/**
 * Get DOAC Validate Details for Loan Summary
 * Note: Renamed to avoid conflict with doacvalidate.service.ts
 */
export const getDoacValidateDetailsForLoanSummary = async (
  product: string
): Promise<ILoanSummaryDoacResponse> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  try {
    const response = await encryptedRequest<ILoanSummaryDoacResponse>({
      method: "POST",
      url: API_PATHS.doacValidate,
      data: {
        mobileNo,
        product,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return {} as ILoanSummaryDoacResponse;
  }
};
